export default "__VITE_ASSET__BhGG1vU9__"